<template>
  <div class="download" v-show="!isFromApp">
    <div class="download-left">
      <div class="download-left-logo">
        <img src="../assets/img/logo@2x.png" alt="" />
      </div>
      <div class="download-left-text">
        <h3>鹏扬基金官方APP</h3>
        <span>投资创造美好未来</span>
      </div>
    </div>
    <div class="download-right">
      <div @click="handleDownload">
        <span>立即下载</span>
      </div>
    </div>
  </div>
</template>
<script>
// import { MessageBox } from 'mint-ui'

export default {
  name: '',
  data () {
    return {}
  },
  methods: {
    getOs () {
      let ua = navigator.userAgent
      let isWindowsPhone = /(?:Windows Phone)/.test(ua)
      let isSymbian = /(?:SymbianOS)/.test(ua) || isWindowsPhone
      let isAndroid = /(?:Android)/.test(ua)
      let isFireFox = /(?:Firefox)/.test(ua)
      // isChrome = /(?:Chrome|CriOS)/.test(ua),
      let isTablet = /(?:iPad|PlayBook)/.test(ua) || (isAndroid && !/(?:Mobile)/.test(ua)) || (isFireFox && /(?:Tablet)/.test(ua))
      let isPhone = /(?:iPhone)/.test(ua) && !isTablet
      let isWeiXin = ua.toLowerCase().indexOf('micromessenger') !== -1
      let isPc = !isPhone && !isAndroid && !isSymbian
      return {
        isTablet: isTablet,
        isPhone: isPhone,
        isAndroid: isAndroid,
        isPc: isPc,
        isWeiXin
      }
    },
    handleDownload () {
      var data = OpenInstall.parseUrlParams() // openinstall.js中提供的工具函数，解析url中的所有查询参数
      // eslint-disable-next-line no-new
      new OpenInstall({
        /* appKey必选参数，openinstall平台为每个应用分配的ID */
        appKey: 'akw0q7',
        /* 自定义遮罩的html */
        // mask:function(){
        //  return "<div id='_shadow' style='position:fixed;left:0;top:0;background:rgba(0,255,0,0.5);filter:alpha(opacity=50);width:100%;height:100%;z-index:10000;'></div>"
        // },
        /* OpenInstall初始化完成的回调函数，可选 */
        onready: function () {
          /* 在app已安装的情况尝试拉起app */
          this.schemeWakeup()
          // eslint-disable-next-line one-var
          var m = this
          m.wakeupOrInstall()
        }
      }, data)
    },
    // ios 8 之前 和 android
    jumpIosAppStore () {
      location.href = 'weixin://'
    }
  },
  computed: {
    isFromApp () {
      // return true
      var data = OpenInstall.parseUrlParams()
      return data.source === 'APP' || data.source === 'app'
    }
  }
}
</script>
<style
  lang="scss"
  scoped
>
.download {
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 1.707rem;
  padding: 0.32rem 0.4rem;
  background-color: #ffffff;
  box-shadow: 0px -9px 16px #333333;
  z-index: 999;
  .download-left {
    display: flex;
    .download-left-logo {
      width: 1.067rem;
      height: 1.067rem;
      margin-right: 0.267rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .download-left-text {
      display: flex;
      flex-direction: column;
      justify-content: center;

      h3 {
        line-height: 0.587rem;
        color: #222222;
        font-size: 0.4rem;
        font-weight: bold;
      }

      span {
        line-height: 0.453rem;
        font-size: 0.293rem;
        color: #999999;
        font-weight: 400;
        font-family: 'PingFangSC-Regular', '微软雅黑', sans-serif;
      }
    }
  }

  .download-right {
    div {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 2.08rem;
      height: 0.747rem;
      border: 0.5px solid rgba(239, 60, 52, 0.2);
      border-radius: 14px;

      span {
        line-height: 0.747rem;
        text-align: center;
        font-size: 0.32rem;
        color: #ef3c34;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DownloadApp.vue